export default __webpack_public_path__ + "63adc2acdf70ac2f6ba6b7adfa40f566.png";